import { render, staticRenderFns } from "./AscParameterAlertDialog.vue?vue&type=template&id=1cffbfba&scoped=true&"
import script from "./AscParameterAlertDialog.vue?vue&type=script&lang=js&"
export * from "./AscParameterAlertDialog.vue?vue&type=script&lang=js&"
import style0 from "./AscParameterAlertDialog.vue?vue&type=style&index=0&id=1cffbfba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cffbfba",
  null
  
)

export default component.exports